import { models } from "./models.js";

function createNavigation(translate) {
  return {
    research: {
      label: translate("nav.research"),
      href: "https://www.nature.com/subjects/machine-learning",
      external: true,
    },
    modelGroups: [
      {
        heading: translate("nav.omniModel"),
        items: models.map((model) => ({
          label: model.name,
          href: model.redirectUrl,
          external: true,
        })),
      },
    ],
    newsGroups: [
      {
        items: [
          {
            label: translate("nav.openAiNews"),
            href: "https://openai.com/news",
            external: true,
          },
          {
            label: translate("nav.googleDeepMind"),
            href: "https://deepmind.google/discover/blog",
            external: true,
          },
          {
            label: translate("nav.natureAi"),
            href: "https://www.nature.com/subjects/artificial-intelligence",
            external: true,
          },
        ],
      },
    ],
    pricingGroups: [
      {
        items: [
          {
            label: translate("nav.officialApiPricing"),
            href: "https://openrouter.ai/models?utm_source=chatgpt.com",
            external: true,
          },
          {
            label: translate("nav.tokenPricing"),
            href: "https://www.15token.win/keys",
            external: true,
          },
        ],
      },
    ],
    usageGroups: [
      {
        heading: translate("nav.docsMenu"),
        items: [
          {
            label: translate("nav.tutorial"),
            href: "https://pcnua8dpmgop.feishu.cn/docx/SSYRdjDQyouztxxJfWcc5ZV3n7f?from=from_copylink",
            external: true,
          },
          {
            label: translate("nav.getApiKey"),
            href: "https://www.15token.win/keys",
            external: true,
          },
          {
            label: translate("nav.console2"),
            href: "https://www.15token.win/dashboard",
            external: true,
          },
        ],
      },
      {
        heading: translate("nav.agent"),
        items: [
          {
            label: translate("nav.kimiCode"),
            href: "https://www.kimi.com/code/zh",
            external: true,
          },
          {
            label: translate("nav.deepSeekHarness"),
            href: "https://www.deepseek.com/en/harness/",
            external: true,
          },
          {
            label: translate("nav.codex"),
            href: "https://www.chatgpt.com/codex",
            external: true,
          },
          {
            label: translate("nav.claudeCode"),
            href: "https://claude.com/product/claude-code",
            external: true,
          },
        ],
      },
    ],
  };
}
export { createNavigation };
